module.exports = __webpack_public_path__ + "static/media/seed0814.c996ae62.png";